"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = __importDefault(require("./Base"));
var SearchboxCollab = /** @class */ (function (_super) {
    __extends(SearchboxCollab, _super);
    function SearchboxCollab(version) {
        var _this = _super.call(this, version.id) || this;
        _this.get = function () {
            return _this.getByPath(_this.path());
        };
        _this.getIdsForUser = function (uid) {
            return _this.getByPath("/users_mapping/searchboxcollab/" + uid);
        };
        _this.getConfig = function (orgId) {
            return _this.getByPath("/searchboxcollab_config/" + orgId);
        };
        _this.path = function () {
            var versionId = _this.version.id;
            var query = _this.version.getQuery();
            var queryId = query.id;
            var analysis = query.getAnalysis();
            var analysisId = analysis.id;
            var orgId = analysis.getOrgId();
            return "/collabs/" + orgId + "/" + analysisId + "/" + queryId + "/" + versionId + "/searchbox";
        };
        _this.version = version;
        return _this;
    }
    return SearchboxCollab;
}(Base_1.default));
exports.default = SearchboxCollab;
//# sourceMappingURL=SearchboxCollab.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/SearchboxCollab.js
// module id = 1616
// module chunks = 8